import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { AccountInfo } from "@azure/msal-browser";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class UserService {
    public activeAccountBehavior$ = new BehaviorSubject<AccountInfo>({} as AccountInfo);
    activeAccountChange$ = this.activeAccountBehavior$.asObservable();

    constructor(private msalAuthService: MsalService) {
        this.activeAccountBehavior$.next(this.msalAuthService.instance.getAllAccounts()[0]);
    }
}
